module.exports = __webpack_public_path__ + "img/imgp8786.f8053893.jpg";